import React, { useContext } from "react";
import { LiaCheckCircleSolid } from "react-icons/lia";
import { RxCrossCircled } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { timeElapsed } from "../../services/getTimeSended";
import Person from "../Person";
import { socket } from "../../services/socket";
import { AuthContext } from "../../contexts/AuthContext";

export default function DropdownItem({ notification }) {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { data, type, read, createdAt, sender, removedMember } = notification;

  const senderNom = sender
    ? `${sender.prenom} ${sender.nom}`
    : "Inconnu";

  const removedMemberNom = removedMember
    ? `${removedMember.prenom} ${removedMember.nom}`
    : "un membre";

  const getNotificationMessage = () => {
    switch (type) {
      case "groupe_invitation":
        return `vous a ajouté dans le groupe "${data.groupeNom}"`;
      case "groupe_member_left":
        return `a quitté le groupe "${data.groupeNom}"`;
      case "groupe_admin_transferred":
        return `a quitté le groupe "${data.groupeNom}" et vous êtes devenu administrateur`;
      case "groupe_member_added":
        return `vous a ajouté dans le groupe "${data.groupeNom}"`;
      case "groupe_member_removed":
        if (removedMember && removedMember._id?.toString() === user.userId) {
          return `vous a retiré du groupe "${data.groupeNom}"`;
        }
        return `a retiré ${removedMemberNom} du groupe "${data.groupeNom}"`;
      default:
        return "notification";
    }
  };

  const showVisitButton = type === "groupe_invitation" || type === "groupe_member_added" || type === "groupe_admin_transferred";

  return (
    <li style={{ opacity: read ? 0.5 : 1 }}>
      <div className="tyn-media-group">
        <Person
          person={{
            image: sender?.userImage || "",
            nom: sender?.nom || "",
            prenom: sender?.prenom || "",
            userId: sender?._id || "",
            colors: sender?.color,
          }}
          animate={
            !read
              ? "animate__flash animate__animated animate__slower animate__infinite tyn-media tyn-circle"
              : "tyn-media tyn-circle"
          }
        />
        <div className="tyn-media-col">
          <div className="tyn-media-row">
            <div className="message mon-text-toujours-dans-la-div">
              <strong>{senderNom} </strong>
              {getNotificationMessage()}
            </div>
          </div>
          <div className="tyn-media-row">
            <span className="meta" style={{fontSize:"7px !important"}}>
              {timeElapsed(new Date(createdAt).getTime()) === "À l'instant"
                ? "À l'instant"
                : `Depuis, ${timeElapsed(new Date(createdAt).getTime())}`}
            </span>
          </div>
          <div className="tyn-media-row">
            <ul className="tyn-btn-inline gap gap-3 pt-1">
              {showVisitButton && (
                <li>
                  <button
                    className="btn btn-md btn-primary"
                    onClick={() => {
                      socket.emit("mark_notification_read", notification._id);
                      if (data.roomId) {
                        navigate(`/groupes/${data.roomId}`);
                      } else {
                        navigate("/groupes");
                      }
                    }}
                  >
                    <LiaCheckCircleSolid />
                    <span>Visiter</span>
                  </button>
                </li>
              )}
              <li>
                <button
                  className="btn btn-md btn-light bg-danger text-white"
                  onClick={() => {
                    socket.emit("delete_notification", notification._id);
                  }}
                >
                  <RxCrossCircled />
                  <span>Fermer</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </li>
  );
}
